<!-- 视频通话 -->
<template>
  <div v-show="visible" class="showvideo">
    <div class="topinfo">
      <h2>{{ xhData.lxhd || '' }}</h2>
      <p>
        <b>巡河人</b>
        <span>{{ xhData.userName || '' }}</span>
      </p>
      <p>
        <b>联系电话</b>
        <span>{{ xhData.lxdh || '' }}</span>
      </p>
    </div>
    <div class="videoinfo" :class="fullvideo ? 'full' : ''" @click="fullsc">
      <rtc-video ref="rtcVideo" class="rtcVideo"></rtc-video>
    </div>
    <div class="videotool" :class="fullvideo ? 'full' : ''">
      <p>{{ callText }}</p>
      <img src="@/assets/img/map/gd.png" @click="callend" />
      <p>挂断退出</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import rtcVideo from '@/components/map/rtctx.vue'
import { Api } from '@/api/publicApi'
import { Api2 } from '@/api/videoCallApi'
const api = new Api()
const api2 = new Api2()

export default {
  props: {
    visible: {
      required: true,
    },
    xhData: {
      required: undefined,
    },
  },
  components: {
    rtcVideo,
  },
  data() {
    return {
      userInfo: {
        userId: '',
        xhrmc: '',
        lxdh: '',
        id: '',
      },
      fullvideo: false,
      callText: '响铃中',
      gjs: [],
      time: 0,
      intervalID: null,
    }
  },
  methods: {
    setUserInfo(userData) {
      this.userInfo = userData
    },
    async calluser() {
      const that = this
      await window.clearInterval(this.intervalID)
      await this.$refs.rtcVideo.leave()
      // let channelId = this.userInfo.lxdh;
      // 随机生成房间号，取值范围为 1~4294967295
      // let channelId = channelId = parseInt(Math.random() * 4294967295);

      //房间状态，判断是否已有房间
      await api2.openapi
        .getStatusUsingGET_2({ channelNo: this.xhData.userId })
        .then(async (res) => {
          // if (res == 200 && (!res.data || res.data.status == 3)) {
          //   //改变用户状态
          //   await api2.openapi.createUsingPOST_2({
          //     channelNo: this.xhData.userId,
          //     userId: this.xhData.userId,
          //     state: 1,
          //   })
          // }
          await api2.openapi.createUsingPOST_2({
            channelNo: this.xhData.userId,
            userId: this.xhData.userId,
            state: 1,
          })
          this.callText = '响铃中'
          setTimeout(() => {
            that.$refs.rtcVideo.init(this.xhData.userId)
          }, 500)
          // 检查通话状态轮询
          const self = this
          // 通话状态轮询时间间隔ID
          that.time = 1
          that.intervalID = window.setInterval(async function () {
            if (self.time) {
              self.time++
            }
            // 房间状态有3种，1是响铃中，2是通话中，3是已挂断
            await api2.openapi
              .getStatusUsingGET_2({ channelNo: self.xhData.userId })
              .then((res2) => {
                if (res2.code === 200) {
                  if (res2.data && res2.data.status === 3) {
                    // 对方已挂断
                    self.callText = '对方已挂断'
                    self.time = 0
                    window.$message2.warning('对方已挂断')
                    window.clearInterval(that.intervalID)
                  } else if (res2.data && res2.data.status === 2) {
                    // 对方已接通，通话中
                    self.callText = '通话中'
                    self.time = 0
                  }
                }
              })
            if (self.time == 30) {
              self.time = 0
              window.$message2.warning('无人接听，可能对方正忙')
            }
          }, 1000)
        })
    },
    fullsc() {
      this.fullvideo = !this.fullvideo
    },
    async callend() {
      if (this.intervalID) {
        window.clearInterval(this.intervalID)
      }
      await api2.openapi
        .closeUsingPOST_2({
          channelNo: this.xhData.userId,
          userId: this.xhData.userId,
        })
        .then(() => {
          this.callText = '响铃中'
        })
      this.$emit('hideCall')
      // await this.$refs.rtcVideo.unpublish()
      // await this.$refs.rtcVideo.unsubscribe()
      await this.$refs.rtcVideo.leave()
      this.fullvideo = false
    },
  },
  mounted() {
    // this.calluser();
  },
  created() {},
}
</script>

<style lang="scss" scoped>
.showvideo {
  position: absolute;
  top: 180px;
  left: 35rem;
  width: 26rem;
  pointer-events: auto;
  z-index: 99999;

  .topinfo {
    background: #ccf2ff10;
    padding: 1rem;

    h2 {
      font-size: 1.5rem;
      color: #ccf2ff;
      margin: 0.8rem;
    }

    p {
      display: flex;
      justify-content: space-between;
      margin: 0.25rem 0;

      b {
        color: #9bd0ff;
      }

      span {
        color: #ccf2ff;
      }
    }

    &.full {
      display: none;
    }
  }

  .videoinfo {
    // width: 100%;
    height: 48rem;
    padding: 1rem;
    background: #ccf2ff10;
    margin: 0;

    &.full {
      position: fixed;
      left: 39%;
      top: 6%;
      width: 20vw;
      height: 44vw;
      max-height: none;
      z-index: 999999;
    }

    .rtcVideo {
      width: 100%;
      height: 100%;
      background: #ccf2ff10;
    }
  }

  .videotool {
    margin-top: 0;
    padding: 1rem;
    background: #ccf2ff10;
    text-align: center;
    color: #ccf2ff;

    & > p {
      margin: 1rem 0;
    }

    img {
      margin: 0.5rem;
      cursor: pointer;
    }

    &.full {
      background: none;
      position: fixed;
      left: 34%;
      top: calc(44vw - 2%);
      width: 30vw;
      z-index: 9999999;

      p {
        display: none;
      }

      img {
        width: 10%;
      }
    }
  }
}
</style>
